import "core-js/modules/es.array.push.js";
import navIcon from "@/components/Tm-icon.vue";
export default {
  components: {
    navIcon
  },
  name: "myMenu",
  props: ["data", "collapse"],
  mounted() {},
  methods: {
    toRouer(item) {
      if (item.path === "/home/Welcome") {
        this.$router.push(item.path);
      } else {
        const arrPath = item.ename.split("/");
        const routePath = arrPath[arrPath.length - 1];
        this.$router.push("/home/" + routePath);
      }
    }
  }
};